import { useContext } from "react";
import { Table, Tag } from "antd";
import { CopyOutlined } from "@ant-design/icons";

import useCityInvoices from "./useCityInvoices";
import PageHeader from "../../components/PageHeader";
import ActiveFiltersBar from "../../components/ActiveFiltersBar";
import TableCard from "../../components/TableCard";
import TableDicaHint from "../../components/TableDicaHint";
import TablePagination from "../../components/TablePagination";
import ModalInvoiceDetails from "./components/ModalInvoiceDetails";
import { ThemeContext } from "../../contexts/ThemeContext";
import { poeValorComPontosEmMil } from "../../utils/Conversores";

export default function CityInvoicesDuplicated() {
    const { theme } = useContext(ThemeContext);
    const isDark = theme === "dark";

    const {
        columns,
        isLoading,
        tableData,
        totalItems,
        handleTableChange,
        handlePaginationChange,
        handleClearAllFilters,
        tableParams,
        activeFilterItems,
        showModalInvoice,
        handleShowModalInvoice,
        invoiceSelected,
        setInvoiceSelectedKey,
        reloadInvoices,
    } = useCityInvoices();

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <PageHeader
                icon={<CopyOutlined />}
                title="Possíveis Notas Duplicadas"
                tag={<Tag color="volcano">{poeValorComPontosEmMil(totalItems || 0)} grupos</Tag>}
                subtitle="Identificação de notas fiscais do mesmo cidadão/usuário com o mesmo valor e tipos distintos."
            />

            <ActiveFiltersBar
                filters={activeFilterItems}
                onClearAll={handleClearAllFilters}
            />

            <TableDicaHint text="Dê um clique na linha ou utilize o botão de ação para abrir o comparador lado a lado e validar as notas do grupo." />

            <TablePagination
                current={tableParams.pagination.current}
                pageSize={tableParams.pagination.pageSize}
                total={totalItems}
                itemName="grupos"
                pageSizeOptions={["10", "25", "50", "100"]}
                onChange={handlePaginationChange}
            />

            <TableCard>
                <Table
                    rowKey="rowKey"
                    className={`modern-data-table ${isDark ? "modern-data-table-dark" : ""}`}
                    columns={columns}
                    dataSource={tableData}
                    loading={isLoading}
                    pagination={false}
                    scroll={{ x: 900 }}
                    onChange={handleTableChange}
                    onRow={(record) => ({
                        onClick: () => {
                            setInvoiceSelectedKey(record.rowKey);
                            handleShowModalInvoice();
                        },
                        style: {
                            cursor: "pointer",
                        },
                    })}
                />
            </TableCard>

            <TablePagination
                current={tableParams.pagination.current}
                pageSize={tableParams.pagination.pageSize}
                total={totalItems}
                itemName="grupos"
                pageSizeOptions={["10", "25", "50", "100"]}
                onChange={handlePaginationChange}
            />

            <ModalInvoiceDetails
                open={showModalInvoice}
                onClose={handleShowModalInvoice}
                onRefresh={reloadInvoices}
                invoice={invoiceSelected}
            />
        </div>
    );
}